import { ColorScheme, DocumentFile, User } from "@/types/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SystemState = {
  version: string;
  error: string;
  colorScheme: ColorScheme;
  logoFile: DocumentFile | null;
  user: User | null;
};

const initialState: SystemState = {
  version: "",
  error: "",
  colorScheme: {
    primaryColor: "",
    secondaryColor: "",
  },
  logoFile: null,
  user: null,
};

const systemSlice = createSlice({
  name: "system",
  initialState,
  reducers: {
    setVersion(state, { payload }) {
      state.version = payload;
    },
    setError(state, { payload }) {
      state.error = payload;
    },
    setColorScheme(state, { payload }) {
      state.colorScheme.primaryColor = payload.primaryColor;
      state.colorScheme.secondaryColor = payload.secondaryColor;
    },
    setLogo(state, { payload }) {
      state.logoFile = payload;
    },
    setUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
  },
});

export const systemActions = systemSlice.actions;
export default systemSlice;
